// Admin-configurable name for task sections ("Разделы" → "Локации", "Проекты", …).
// Only dictionary names can be chosen, so every phrase is declined; an unknown stored value falls back to "Разделы".

// [nomSg, genSg, accSg, nomPl, genPl, gender, enSg, enPl]
const KNOWN = [
  ["раздел", "раздела", "раздел", "разделы", "разделов", "m", "section", "sections"],
  ["локация", "локации", "локацию", "локации", "локаций", "f", "location", "locations"],
  ["проект", "проекта", "проект", "проекты", "проектов", "m", "project", "projects"],
  ["объект", "объекта", "объект", "объекты", "объектов", "m", "object", "objects"],
  ["площадка", "площадки", "площадку", "площадки", "площадок", "f", "site", "sites"],
  ["участок", "участка", "участок", "участки", "участков", "m", "plot", "plots"],
  ["территория", "территории", "территорию", "территории", "территорий", "f", "territory", "territories"],
  ["здание", "здания", "здание", "здания", "зданий", "n", "building", "buildings"],
  ["дом", "дома", "дом", "дома", "домов", "m", "house", "houses"],
  ["склад", "склада", "склад", "склады", "складов", "m", "warehouse", "warehouses"],
  ["направление", "направления", "направление", "направления", "направлений", "n", "area", "areas"],
  ["отдел", "отдела", "отдел", "отделы", "отделов", "m", "department", "departments"],
  ["подразделение", "подразделения", "подразделение", "подразделения", "подразделений", "n", "division", "divisions"],
  ["филиал", "филиала", "филиал", "филиалы", "филиалов", "m", "branch", "branches"],
  ["категория", "категории", "категорию", "категории", "категорий", "f", "category", "categories"],
];

const cap = (value) => value.charAt(0).toUpperCase() + value.slice(1);

// Names the admin can choose from (the stored value is the Russian plural).
export const SECTION_TERM_OPTIONS = KNOWN.map((entry) => ({ value: cap(entry[3]), en: cap(entry[7]) }));
const norm = (value) => String(value || "").trim().toLowerCase().replace(/ё/g, "е");

export function findSectionTerm(term) {
  const key = norm(term);
  return KNOWN.find((entry) => entry[0] === key || entry[3] === key) || null;
}

export function sectionTerms(term, locale) {
  const known = findSectionTerm(term) || KNOWN[0];
  const en = locale === "en";

  const [nom, gen, acc, pl, genPl, g, enSg, enPl] = known;
  if (en) {
    return {
      plural: cap(enPl),
      singular: cap(enSg),
      missing: enSg,
      all: `All ${enPl}`,
      choose: `Choose ${enPl}`,
      none: `No ${enSg}`,
      createLead: `Fill in the task details and choose a ${enSg}`,
      required: `Choose at least one ${enSg}`,
      newItem: `New ${enSg}`,
      edit: `Edit ${enSg}`,
      remove: `Delete ${enSg}`,
      removeQuestion: `Delete ${enSg}?`,
      removeMessage: (name) => `${cap(enSg)} «${name}» will be deleted`,
      empty: `No ${enPl} yet`,
      dialogLead: `${cap(enSg)} name and description for grouping tasks`,
      defaultLabel: `Default ${enSg}`,
      defaultHint: `Preselected for new tasks. Only one ${enSg} can be the default`,
      allowDefault: `Allow default ${enPl}`,
      moveTitle: `Move tasks to another ${enSg}`,
    };
  }
  const form = (m, f, n) => ({ m, f, n })[g];
  return {
    plural: cap(pl),
    singular: cap(nom),
    missing: nom,
    all: `Все ${pl}`,
    choose: `Выберите ${pl}`,
    none: `Без ${gen}`,
    createLead: `Заполните основные данные и выберите ${acc}`,
    required: `Выберите хотя бы ${form("один", "одну", "одно")} ${acc}`,
    newItem: `${form("Новый", "Новая", "Новое")} ${nom}`,
    edit: `Изменить ${acc}`,
    remove: `Удалить ${acc}`,
    removeQuestion: `Удалить ${acc}?`,
    removeMessage: (name) => `${cap(nom)} «${name}» будет ${form("удалён", "удалена", "удалено")}`,
    empty: `${cap(genPl)} пока нет`,
    dialogLead: `Название и описание ${gen} для группировки задач`,
    defaultLabel: `${cap(nom)} по умолчанию`,
    defaultHint: `Предвыбирается при создании новой задачи. По умолчанию может быть только ${form("один", "одна", "одно")} ${nom}`,
    allowDefault: `Разрешить использование ${genPl} по умолчанию`,
    moveTitle: `Перенести задачи в ${form("другой", "другую", "другое")} ${acc}`,
  };
}
